var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 38 18"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 17,
  x: 0.5,
  y: 0.5,
  stroke: "#96B7F9",
  rx: 4.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#96B7F9",
  d: "M10.249 6h1.28v5.86h2.88V13h-4.16zm5 0h1.28v7h-1.28zm4.182 1.24h-1.98V6h5.24v1.24h-1.98V13h-1.28zM23.608 6h4.48v1.24h-3.17v1.49h2.46v1.24h-2.46v1.79h3.27V13h-4.58z"
})));
export { SvgLite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAzOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzNyIgaGVpZ2h0PSIxNyIgcng9IjQuNSIgc3Ryb2tlPSIjOTZCN0Y5Ii8+CjxwYXRoIGQ9Ik0xMC4yNDg1IDZIMTEuNTI4NVYxMS44NkgxNC40MDg1VjEzSDEwLjI0ODVWNlpNMTUuMjQ4NSA2SDE2LjUyODVWMTNIMTUuMjQ4NVY2Wk0xOS40MzA4IDcuMjRIMTcuNDUwOFY2SDIyLjY5MDhWNy4yNEgyMC43MTA4VjEzSDE5LjQzMDhWNy4yNFpNMjMuNjA3OSA2SDI4LjA4NzlWNy4yNEgyNC45MTc5VjguNzNIMjcuMzc3OVY5Ljk3SDI0LjkxNzlWMTEuNzZIMjguMTg3OVYxM0gyMy42MDc5VjZaIiBmaWxsPSIjOTZCN0Y5Ii8+Cjwvc3ZnPgo=";